import jhon from './img/1.jpg';
import javaScript from './images/javaScript.png';
import nodejs from './images/node-js.png';
import react from './images/react.png';
import mySql from './images/mySql.png';
import css from './images/css.png';
import acqualine from './img/acqualine.jpg';
import tfc from './img/tfc.jpg';
import recipesApp from './img/recipesApp.jpg';
import typesS from './images/typesS.png';

export const Data = [
    {
        title: 'Delivery app',
        img: jhon,
        link: 'https://github.com/LucasBelgamann/delivery_app',
        description: 'Aplicação que vai do banco de dados até a interface do usuário, sendo o principal objetivo desenvolver um app de delivery para uma distribuidora de bebidas.',
        techs: [
            {
                img: javaScript
            },
            {
                img: nodejs
            },
            {
                img: mySql
            },
            {
                img: css
            },
            {
                img: react
            }
        ]
    },
    {
        title: 'App de receitas',
        img: recipesApp,
        link: 'https://recipes-app-project-umber.vercel.app/',
        description: 'O app de receitas é um projeto onde foi contruido um aplicativo de receitas, que no qual o usuário tem a possibilidade de de favoritar, salvar, compartilhar uma receita.',
        techs: [
            {
                img: javaScript
            },
            {
                img: css
            },
            {
                img: react
            }
        ]
    },
    {
        title: 'Futebol clube',
        img: tfc,
        link: 'https://github.com/LucasBelgamann/futebol-clube',
        description: 'Nesse projeto foi contruido um back-end/banco de dados para que a API fosse capaz de ser consumida pelo front-end da aplicação.',
        techs: [
            {
                img: typesS
            },
            {
                img: nodejs
            },
            {
                img: mySql
            },
        ]
    },
    {
        title: 'Acqualine',
        img: acqualine,
        link: 'https://acqualine.vercel.app/',
        description: 'Nesse projeto, foi contruido uma interface para o usuário onde o principal obejtivo é a divulgação dos serviços e produtos da loja.',
        techs: [
            {
                img: react
            },
            {
                img: css
            },
        ]
    },
]
